import React, { useState, useEffect, useRef } from "react";
import "./ItineraryDetails.css";
//import { Base64 } from "js-base64";
import NewHeader from "../../Component/NewHeader/NewHeader";
import Modal from "react-modal";
import { Helmet } from "react-helmet";
import "react-google-flight-datepicker/dist/main.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import Slider from "react-slider-modal";
import AccomodationListingPopup from "./AccomodationListingPopup";
import ExperienceListingPopup from "./ExperienceListingPopup";
import ExperienceTransferListingPopup from "./ExperienceTransferListingPopup";
import ExperienceTransferFerryListingPopup from "./ExperienceTransferFerryListingPopup";
import VerticalTabsScrollable from "./VerticalTabsScrollable";
import {
  checkAvailabilityCheckoutData,
  WishlistfitCartAdd,
  shareItineraryDetails,
  LoginConfirmation,
} from "../../Component/axios";
import SignUp from "../../Component/SignUp";
import FacebookLogin from "react-facebook-login";
import { GoogleLogin, GoogleLogout } from "react-google-login";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { setCustomerLogin } from "../../Component/axios";
import { removeToCart, clearToCart } from "../../redux/actions/actions";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceItinerary from "./InvoiceItinerary/Invoice";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import Summarydetails from "./Summarydetails";
import TawkToWidget from "../TawkToWidget";

function ItineraryDetails() {
  const selectedData = useSelector((state) => state.cardItems.cardData);
  const dispatch = useDispatch();
  //const [selectedData, setselectedData] = useState(selectedDataNew); 
  const [cookies, setCookie] = useCookies(["userDetails"]);
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [slideShow, setslideShow] = useState(false);
  const [slideExperienceShow, setslideExperienceShow] = useState(false);
  const [
    slideExperienceTransferShow,
    setslideExperienceTransferShow,
  ] = useState(false);
  const [
    slideExperienceTransferFerryShow,
    setslideExperienceTransferFerryShow,
  ] = useState(false);

  const [cats, setcats] = useState([
    { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
  ]);
  const [itineraryPlan, setitineraryPlan] = useState([]);
  const [addMoreLocation, setaddMoreLocation] = useState([]);
  const [changeDate, setchangeDate] = useState([]);
  const [planname, setplanname] = useState("");
  const [selectedStartLocation, setselectedStartLocation] = useState("");
  const [selectedEndLocation, setselectedEndLocation] = useState("");
  const [totalDays, settotalDays] = useState("");
  const [totalLocation, settotalLocation] = useState("");
  const [plandate, setplandate] = useState([]);
  const [itineraryDetails, setitineraryDetails] = useState([]);
  const [DatesOfDay, setDatesOfDay] = useState([]);
  //const [sequenceDate, setsequenceDate] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [summaryTabData, setSummaryTabData] = useState([]);
  const [activityRequest, setactivityRequest] = useState({});
  const [transferRequest, settransferRequest] = useState({});
  const [transferFerryRequest, settransferFerryRequest] = useState({});
  const [accommodationRequest, setaccommodationRequest] = useState({});
  const [selectedDate, setSelectedDate] = useState([]);
  // const [selectedTimeData, setSelectedTimeData] = useState([]);
  const [accommodationLen, setaccommodationLen] = useState(0);
  const [attractionLen, setattractionLen] = useState(0);
  const [transferLen, settransferLen] = useState(0);
  const [transferFerryLen, settransferFerryLen] = useState(0);
  const [openModal, setopenModal] = useState(false);
  const [reduxData, setreduxData] = useState(null);
  const [checkAvailData, setcheckAvailData] = useState(null);
  const [customerDetails, setcustomerDetails] = useState(
    localStorage.getItem("userDetails") || "abc"
  );
 
 
  const [value, setValue] = useState("1");
  // const [redirect, setRedirect] = useState(false);
  // const [LoginPage, setLoginPage] = useState(false);

  const [modalIsOpen, setmodalIsOpen] = useState(false);
  const [facebookLogin, setfacebookLogin] = useState(false);
  const [facebookResponse, setfacebookResponse] = useState({});
  const [GoogleResponse, setGoogleResponse] = useState({});
  const [country, setcountry] = useState("");
  const [country_code, setcountry_code] = useState("");
  const [currency, setcurrency] = useState("");
  const [ip_address, setip_address] = useState("");
  const [ChangeLoginScreenClass, setChangeLoginScreenClass] = useState(
    "containerLogin"
  );
  const [EmailId, setEmailId] = useState();
  const [LoginEmail, setLoginEmail] = useState("");
  const [LoginPassword, setLoginPassword] = useState("");
  const [errorPassword, seterrorPassword] = useState(false);
  const [EmailError, setEmailError] = useState(false);
  const [openPlanModal, setopenPlanModal] = useState(false);
  const [tripPlanNameValue, setTripPlanNameValue] = useState("");
  const [tripPlanNameErrorMessage, setTripPlanNameErrorMessage] = useState("");
  const [servicedate, setServicedate] = useState([]);
  const [openModalShare, setopenModalShare] = useState(false);
  const [pdfLink, setPdfLink] = useState("");

  const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZoneval = urlParams.get("moreLocation");
    const checkin = urlParams.get("checkin");
    const checkout = urlParams.get("checkout");
    const guestCombination = urlParams.get("guestCombination");
    const itineraryPlan = urlParams.get("itineraryPlan");
    const changeDate = urlParams.get("changeDate");
    const selectedStartLocation = urlParams.get("selectedStartLocation");
    const selectedEndLocation = urlParams.get("selectedEndLocation");
    let defaultZonevalJSON = JSON.parse(defaultZoneval);
    let changeDateJSON = JSON.parse(changeDate);

    let querySearch = JSON.parse(guestCombination);

    setchangeDate(changeDateJSON);
    setitineraryPlan(itineraryPlan);
    setaddMoreLocation(defaultZonevalJSON);
    setstartDate(checkin);
    setendDate(checkout);
    setcats(querySearch);
    setselectedStartLocation(selectedStartLocation);
    setselectedEndLocation(selectedEndLocation);

    JSON.parse(itineraryPlan).map((itemPlan, index) => {
      setplanname(itemPlan.Planname);
      settotalDays(itemPlan.numberOfDay);
      settotalLocation(itemPlan.numberOfLocation);
      setplandate(itemPlan.range);
      setitineraryDetails(itemPlan.children);
    });

    const startDate = new Date(checkin);
    const endDate = new Date(checkout);
    const currentDate = new Date(startDate);

    const datesToRender = [];

    while (currentDate <= endDate) {
      datesToRender.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }
    setDatesOfDay(datesToRender);

    let resultDate = [];
    selectedData.length > 0 &&
      Object.entries(selectedData).map((itemdata, j) => {
        if (itemdata[1]?.serviceDate != "") {
          resultDate.push(itemdata[1]?.serviceDate);
        }
      });
    setSelectedDate(resultDate);

    let Acco = Object.entries(selectedData).filter(
      (i) => i[1].profileactivity == "Accommodations"
    );
    setaccommodationLen(Acco.length);
    let Attraction = Object.entries(selectedData).filter(
      (i) => i[1].profileactivity == "Attraction"
    );
    setattractionLen(Attraction.length);
    let Transfer = Object.entries(selectedData).filter(
      (i) => i[1].profileactivity == "Transfers"
    );
    settransferLen(Transfer.length);

    let TransferFerry = Object.entries(selectedData).filter(
      (i) => i[1].profileactivity == "TransfersFerry"
    );
    settransferFerryLen(TransferFerry.length);


  }, [selectedData]);

  useEffect(() => {
    const savedValue = localStorage.getItem('accomodationSlide');
   
    if (savedValue === true) {
      setslideShow(true);
    } else {
      setslideShow(false);
    }

  }, [localStorage.getItem('accomodationSlide')]);

  useEffect(() => {
   const attractionValue = localStorage.getItem('attractionSlide');
   
    if (attractionValue === true) {
      setslideExperienceShow(true);
    } else {
      setslideExperienceShow(false);
    }
  }, [localStorage.getItem('attractionSlide')]);

  useEffect(() => {
    const transferFerryValue = localStorage.getItem('transferFerrySlide');
     if (transferFerryValue === true) {
       setslideExperienceTransferFerryShow(true);
     } else {
       setslideExperienceTransferFerryShow(false);
     }
   }, [localStorage.getItem('transferFerrySlide')]);

   useEffect(() => {
    const transferValue = localStorage.getItem('transferSlide');
     if (transferValue === true) {
       setslideExperienceTransferShow(true);
     } else {
       setslideExperienceTransferShow(false);
     }
   }, [localStorage.getItem('transferSlide')]);

  useEffect(() => {
    if (selectedDate.length > 0) {
      const serviceDateNew =
        selectedDate.length > 0 &&
        selectedDate.reduce(function (a, b) {
          return a < b ? a : b;
        });
      setServicedate(serviceDateNew);
    }
  }, [selectedDate]);
  const PopuphandleCloseClick = () => {
    setslideShow(false);
    localStorage.setItem('accomodationSlide', false);
  };
  const PopupItineraryDetails = () => {
   
    return (
      <>
        <AccomodationListingPopup
          accommodation={accommodationRequest}
        ></AccomodationListingPopup>
      </>
    );
  };
  const PopuphandleAccomodationListingClick = (
    accoDetails,
    IndexNumber = null
  ) => {
    setslideShow(true);
    let JsonState = {
      defaultZoneval: accoDetails?.Location?.label,
      startDate: moment(accoDetails.range[0].startDate).format("Y-MM-DD"),
      endDate: moment(accoDetails.range[0].endDate).format("Y-MM-DD"),
      guestCombination: cats,
      accopage: 1,
      accosize: 30,
      IndexNumber: IndexNumber,
    };
    const hotelArr = JSON.stringify(JsonState);

    setaccommodationRequest(hotelArr);
  };

  const PopupExperiencehandleCloseClick = () => {
    setslideExperienceShow(false);
    localStorage.setItem('attractionSlide', false);
  };
  const PopupExperienceItinerary = () => {
    return (
      <>
        <ExperienceListingPopup
          experience={activityRequest}
        ></ExperienceListingPopup>
      </>
    );
  };
  const PopuphandleExperienceListingClick = (
    selectedDate,
    defaultZoneval,
    IndexNumber = null
  ) => {
    setslideExperienceShow(true);
    let JsonActivity = {
      defaultZonevalActivityVal: defaultZoneval,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
    };

    let activityArr = JSON.stringify(JsonActivity);
    setactivityRequest(activityArr);
  };

  const PopupExperienceTransferItinerary = () => {
    return (
      <>
        <ExperienceTransferListingPopup
          experiencetransfer={transferRequest}
        ></ExperienceTransferListingPopup>
      </>
    );
  };
  const PopuphandleExperienceTransferListingClick = (
    selectedDate,
    defaultZoneval,
    otherLocation = null,
    IndexNumber = null
  ) => {
    setslideExperienceTransferShow(true);
    let locationData = "";

    if (otherLocation != null) {
      locationData = [defaultZoneval, otherLocation];
    } else {
      locationData = [defaultZoneval];
    }

    let JsonActivity = {
      defaultZonevalTransferVal: locationData,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
    };
    let transferArr = JSON.stringify(JsonActivity);
    settransferRequest(transferArr);
  };

  const PopupExperienceTransferhandleCloseClick = () => {
    setslideExperienceTransferShow(false);
    localStorage.setItem('transferSlide', false);
  };

  //Ferry Transfer Details

  const PopupExperienceTransferFerryItinerary = () => {
    return (
      <>
        <ExperienceTransferFerryListingPopup
          experiencetransfer={transferFerryRequest}
        ></ExperienceTransferFerryListingPopup>
      </>
    );
  };
  const PopuphandleExperienceTransferFerryListingClick = (
    selectedDate,
    defaultZoneval,
    IndexNumber = null
  ) => {
    setslideExperienceTransferFerryShow(true);
    let JsonActivity = {
      defaultZonevalTransferVal: defaultZoneval,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
    };

    let transferArr = JSON.stringify(JsonActivity);
    settransferFerryRequest(transferArr);
  };

  const PopupExperienceTransferFerryhandleCloseClick = () => {
    setslideExperienceTransferFerryShow(false);
    localStorage.setItem('transferFerrySlide', false);
  };

  useEffect(() => {
    const resultData = [];
    DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        let Accomodationinput = itineraryDetails.find(
          (y) =>
            moment(y.range[0].startDate).format("Y-MM-DD") <=
            moment(sequenceDate).format("Y-MM-DD") &&
            moment(y.range[0].endDate).format("Y-MM-DD") >
            moment(sequenceDate).format("Y-MM-DD")
        );
        let itineraryinput = itineraryDetails.find(
          (y) =>
            moment(y.range[0].startDate).format("Y-MM-DD") <=
            moment(sequenceDate).format("Y-MM-DD") &&
            moment(y.range[0].endDate).format("Y-MM-DD") >=
            moment(sequenceDate).format("Y-MM-DD")
        );

        const AccomodationselectedData = Object.entries(selectedData)
          .map(([key, value], index) => ({
            index,  // The index from map
            key,    // Key from the Object.entries()
            data: value, // The actual value from the Object.entries()
          }))
          .filter(({ data }) => data.profileactivity === "Accommodations"); // Filter based on profileactivity

        const TransfersselectedData = Object.entries(selectedData)
          .map(([key, value], index) => ({
            index,  // The index from map
            key,    // Key from the Object.entries()
            data: value, // The actual value from the Object.entries()
          }))
          .filter(({ data }) => data.profileactivity === "Transfers"); // Filter based on profileactivity


        const TransfersFerryselectedData = Object.entries(selectedData)
          .map(([key, value], index) => ({
            index,  // The index from map
            key,    // Key from the Object.entries()
            data: value, // The actual value from the Object.entries()
          }))
          .filter(({ data }) => data.profileactivity === "TransfersFerry"); // Filter based on profileactivity

        const AttractionselectedData = Object.entries(selectedData)
          .map(([key, value], index) => ({
            index,  // The index from map
            key,    // Key from the Object.entries()
            data: value, // The actual value from the Object.entries()
          }))
          .filter(({ data }) => data.profileactivity === "Attraction"); // Filter based on profileactivity

        resultData.push({
          label: moment(sequenceDate).format("DD MMM Y"),

          content: (
            <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
              <div id={`dayplan${indexData}`} day={indexData}></div>
              <div class="dayplan-header">
                <p class="dayplan-title">
                  Day {indexData + 1} -{" "}
                  {selectedStartLocation != "" && indexData == 0 && (
                    <> {selectedStartLocation} - </>
                  )}
                  {itineraryinput?.Location.label}{" "}
                  {Accomodationinput?.Location.label !=
                    itineraryinput?.Location.label && (
                      <> - {Accomodationinput?.Location.label}</>
                    )}
                  {selectedEndLocation != "" &&
                    DatesOfDay.length == indexData + 1 && (
                      <> {selectedEndLocation}</>
                    )}
                </p>
                <div class="day-plan-incusions-container">
                  {/* <div class="inclusions-heading">INCLUDED: </div> */}
                  <div class="day-plan-inclusions">
                    <ul>
                      <li>
                        <span class="holidaySprite icon24 dayPlanHotelIcon"></span>
                        <span>
                          {
                            Object.entries(selectedData).filter(
                              ([key, value]) => {
                                return (
                                  value.profileactivity === "Accommodations" &&
                                  moment(value.startDate).format("Y-MM-DD") <=
                                  moment(sequenceDate).format("Y-MM-DD") &&
                                  moment(value.endDate).format("Y-MM-DD") >
                                  moment(sequenceDate).format("Y-MM-DD")
                                );
                              }
                            ).length
                          }{" "}
                          Hotel
                        </span>
                      </li>
                      <li>
                        <span class="holidaySprite icon24 dayPlanTransferIcon"></span>
                        <span>
                          {
                            Object.entries(selectedData).filter(
                              ([key, value]) => {
                                return (
                                  value.profileactivity === "Transfers" &&
                                  moment(value.dateselected).format(
                                    "Y-MM-DD"
                                  ) === moment(sequenceDate).format("Y-MM-DD")
                                );
                              }
                            ).length
                          }{" "}
                          Land Transfer
                        </span>
                      </li>
                      <li>
                        <span class="holidaySprite icon24 dayPlanActivityIcon"></span>
                        <span>
                          {" "}
                          {
                            Object.entries(selectedData).filter(
                              ([key, value]) => {
                                return (
                                  value.profileactivity === "Attraction" &&
                                  moment(value.dateselected).format(
                                    "Y-MM-DD"
                                  ) === moment(sequenceDate).format("Y-MM-DD")
                                );
                              }
                            ).length
                          }{" "}
                          Activity
                        </span>
                      </li>
                      <li>
                        <span class="holidaySprite icon24 dayPlanActivityIcon"></span>
                        <span>
                          {" "}
                          {
                            Object.entries(selectedData).filter(
                              ([key, value]) => {
                                return (
                                  value.profileactivity === "TransfersFerry" &&
                                  moment(value.dateselected).format(
                                    "Y-MM-DD"
                                  ) === moment(sequenceDate).format("Y-MM-DD")
                                );
                              }
                            ).length
                          }{" "}
                          Ferry
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class="dayplan-section"
                data-testid="day-plan-section-flight"
              >
                <div>
                  <div class="flightListRow flexOne column">
                    <div class="makeFlex">
                      <ul class="flight-row firstFlightRow"></ul>
                    </div>
                  </div>
                </div>
              </div>


              {AccomodationselectedData.length > 0 && (
                DatesOfDay.length == indexData + 1 ? (
                  <> </>
                ) : (
                  <>
                    {
                      Object.entries(selectedData).filter(
                        ([key, value]) => {
                          return (
                            value.profileactivity === "Accommodations" &&
                            moment(value.startDate).format("Y-MM-DD") <=
                            moment(sequenceDate).format("Y-MM-DD") &&
                            moment(value.endDate).format("Y-MM-DD") >
                            moment(sequenceDate).format("Y-MM-DD")
                          );
                        }
                      ).length < 1 && (<>
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-flight"
                        >
                          <div>
                            <div class="flightListRow flexOne column">
                              <div class="makeFlex">
                                <ul class="flight-row firstFlightRow"></ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-activity-container">
                          <div class="add-activity-card">
                            <p class="add-activity-quote">
                              Choose your ideal accommodation for a memorable stay,
                              sorted out by location, special offers applied
                              instantly.
                            </p>
                          </div>
                          <div
                            id="chooseAndAddBtn"
                            class="add-activity-button"
                            data-testid="add-activity-button"
                            onClick={() =>
                              PopuphandleAccomodationListingClick(Accomodationinput)
                            }
                          >
                            <span class="holidaySprite activityIcon"></span>ADD
                            ACCOMMODATIONS
                          </div>
                        </div>
                      </>)
                    }
                  </>)
              )}

              {AccomodationselectedData.length > 0 ? (
                AccomodationselectedData.map((i, j) => {

                  let DataValue = "";
                  if (
                    moment(i.data.startDate).format("Y-MM-DD") <=
                    moment(sequenceDate).format("Y-MM-DD") &&
                    moment(i.data.endDate).format("Y-MM-DD") >
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-hotel"
                        >
                          <div class="hotel-row-wrapper ">
                            <div
                              class="hotel-row highlight "
                              data-testid="hotel"
                            >
                              <div class="hotel-row-header">
                                <p class="hotel-row-title">
                                  Check-in to Hotel in{" "}
                                  {moment(i.data.startDate).format("dddd")},{" "}
                                  {i.data.checkin} and Check-out{" "}
                                  {moment(i.data.endDate).format("dddd")}, ,{" "}
                                  {i.data.checkout}
                                </p>
                                <div
                                  data-testid="changeRemoveBtn_hotel"
                                  id="changeRemoveBtn"
                                  class="hotel-row-btns"
                                >
                                  <span
                                    id="remove"
                                    onClick={() => handleRemove(i?.index)}
                                  >
                                    Remove
                                  </span>
                                  <span
                                    onClick={() =>
                                      PopuphandleAccomodationListingClick(
                                        Accomodationinput,
                                        i?.index
                                      )
                                    }
                                  >
                                    Change
                                  </span>
                                </div>
                              </div>
                              <div class="hotel-row-body">
                                <div class="hotel-row-image-wrapper">
                                  <p class="hotel-row-rating goodRating">
                                    {/* <span class=""></span>4.4<small>/5</small> */}
                                  </p>
                                  <div class=" image-carousel-slide ">
                                    <div
                                      class="imageLoaderContainer "
                                      style={{
                                        width: "243px",
                                        height: "144px",
                                      }}
                                    >
                                      <img
                                        class="borderRadius4 vrtTop active "
                                        width="243"
                                        height="144"
                                        src={i.data.hotelimage}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div class="hotel-row-details">
                                  
                                  <p class="hotel-row-details-title">
                                    {i.data.propertyName}
                                    <span class="holidaySprite rating_blank">
                                      <span class="holidaySprite rating_fill ratingThree"></span>
                                    </span>
                                  </p>
                                  <p class="hotel-row-text-sm">
                                    {i.data.propertylocation}
                                  </p>
                                  <div class="latoBold font11 greyText lineHeight14 "></div>
                                  <p class="hotel-row-text-date">
                                  <FontAwesomeIcon icon={faClock} class="holidaySprite hotelCardCalendar" />
                                    {moment(i.data.startDate).format("D MMM Y")} -{" "}
                                    {moment(i.data.endDate).format("D MMM Y")}
                                  </p>
                                  <div class="makeFlex hrtlCenter">
                                    <p class="hotel-row-hotel-tag">
                                      Accommodations
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div
                              class="room-details-container"
                              data-testid="room-details-container"
                            >
                              <div class="room-title-container">
                                {/* <div class="room-name">Deluxe Room</div> */}
                                <ul class="impInfoCard__list">
                                  {i.data.junifer != null ? (
                                    <>
                                      {i.data.junifer.HotelRooms.HotelRoom
                                        .length > 0 ? (
                                        <>
                                          {" "}
                                          {i.data.junifer.HotelRooms.HotelRoom.map(
                                            (roomname, index) => (
                                              <>
                                                <li>
                                                  <p
                                                    class="latoBlack font14 blackText"
                                                    style={{
                                                      lineHeight: "25px",
                                                    }}
                                                  >
                                                    {roomname.attributes.Units}{" "}
                                                    X {roomname.Name} (
                                                    {i.data.junifer.Board})
                                                  </p>
                                                </li>
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <li>
                                            <p
                                              class="latoBlack font14 blackText"
                                              style={{ lineHeight: "25px" }}
                                            >
                                              {
                                                i.data.junifer.HotelRooms
                                                  .HotelRoom.attributes.Units
                                              }{" "}
                                              X{" "}
                                              {
                                                i.data.junifer.HotelRooms
                                                  .HotelRoom.Name
                                              }{" "}
                                              ({i.data.junifer.Board})
                                            </p>
                                          </li>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {i.data.typedata == "multiple" ? (
                                        <>
                                          {i.data.cartvalue.map(
                                            (cartitem, indexcart) => (
                                              <>
                                                <li>
                                                  <p
                                                    class="latoBlack font14 blackText"
                                                    style={{
                                                      lineHeight: "25px",
                                                    }}
                                                  >
                                                    {cartitem.roomCounter} X{" "}
                                                    {cartitem.name}
                                                  </p>
                                                </li>
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <li>
                                            <p
                                              class="latoBlack font14 blackText"
                                              style={{ lineHeight: "25px" }}
                                            >
                                              1 X {i.data.roomname}
                                            </p>
                                          </li>
                                        </>
                                      )}
                                    </>
                                  )}
                                </ul>
                                {/* <a class="change-room-link">CHANGE ROOM</a> */}
                              </div>
                            </div>

                            </div>
                           
                          </div>
                        </div>
                      </>
                    );
                  }
                  {
                    return <>{DataValue}</>;
                  }
                })
              ) : (
                <>

                  {DatesOfDay.length == indexData + 1 ? (
                    <> </>
                  ) : (
                    <>
                      <div
                        class="dayplan-section"
                        data-testid="day-plan-section-flight"
                      >
                        <div>
                          <div class="flightListRow flexOne column">
                            <div class="makeFlex">
                              <ul class="flight-row firstFlightRow"></ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="add-activity-container">
                        <div class="add-activity-card">
                          <p class="add-activity-quote">
                            Choose your ideal accommodation for a memorable stay,
                            sorted out by location, special offers applied
                            instantly.
                          </p>
                        </div>
                        <div
                          id="chooseAndAddBtn"
                          class="add-activity-button"
                          data-testid="add-activity-button"
                          onClick={() =>
                            PopuphandleAccomodationListingClick(Accomodationinput)
                          }
                        >
                          <span class="holidaySprite activityIcon"></span>ADD
                          ACCOMMODATIONS
                        </div>
                      </div>
                    </>)}
                </>
              )}
              {/* Transfer */}
              {TransfersselectedData.length > 0 && (
                <>
                  <div
                    class="dayplan-section"
                    data-testid="day-plan-section-transfer"
                  >
                    <div class="add-activity-container">
                      <div class="add-activity-card">
                        <p class="add-activity-quote">
                          Craft your perfect itinerary! Connect the
                          dots with convenient transfers.
                        </p>
                      </div>
                      <div
                        id="chooseAndAddBtn"
                        class="add-activity-button"
                        data-testid="add-activity-button"
                        onClick={() =>
                          PopuphandleExperienceTransferListingClick(
                            sequenceDate,
                            itineraryinput?.Location?.label,
                            selectedStartLocation != "" &&
                              indexData == 0
                              ? selectedStartLocation
                              : selectedEndLocation != "" &&
                                DatesOfDay.length == indexData + 1
                                ? selectedEndLocation
                                : null
                          )
                        }
                      >
                        <span class="holidaySprite activityIcon"></span>
                        ADD LAND TRANSFER
                      </div>
                    </div>
                  </div>
                </>
              )}
              {TransfersselectedData.length > 0 ? (
                TransfersselectedData.map((i, j) => {
                  let dateselected = new Date(i.data.dateselected);
                  let DataValue = "";

                  if (
                    moment(dateselected).format("Y-MM-DD") ===
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        {" "}
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-transfer"
                        >
                          <div
                            class="transfer-row highlight "
                            data-testid="transfer"
                          >
                            <div class="transfer-row-header">
                              <p class="transfer-row-title">
                                {i.data.tourLocation}
                              </p>
                              <div
                                id="changeRemoveBtn"
                                class="transfer-row-btns"
                              >
                                <span
                                  id="remove"
                                  onClick={() => handleRemove(i?.index)}
                                >
                                  Remove
                                </span>
                                <span
                                  onClick={() =>
                                    i.data.profileactivity == "Transfers"
                                      ? PopuphandleExperienceTransferListingClick(
                                        sequenceDate,
                                        itineraryinput?.Location?.label,
                                        selectedStartLocation != "" &&
                                          indexData == 0
                                          ? selectedStartLocation
                                          : selectedEndLocation != "" &&
                                            DatesOfDay.length == indexData + 1
                                            ? selectedEndLocation
                                            : null,
                                        i?.index
                                      )
                                      : i.data.profileactivity == "TransfersFerry"
                                        ? PopuphandleExperienceTransferFerryListingClick(
                                          sequenceDate,
                                          itineraryinput?.Location?.label,
                                          j
                                        )
                                        : PopuphandleExperienceListingClick(
                                          sequenceDate,
                                          itineraryinput?.Location?.label,
                                          i?.index
                                        )
                                  }
                                >
                                  Change
                                </span>
                              </div>
                            </div>
                            <div class="transfer-row-body">
                              <div class="transfer-row-image-wrapper">
                                <div class=" image-carousel-slide ">
                                  <div
                                    class="imageLoaderContainer "
                                    style={{
                                      width: "243px",
                                      height: "144px",
                                    }}
                                  >
                                    <img
                                      class="borderRadius4 vrtTop active "
                                      width="243"
                                      height="144"
                                      src={i.data.tourImage}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="transfer-row-details">
                                <div class="transfer-row-details-title">
                                  <p class="greyText">
                                    <span class="font14 latoBlack blackText">
                                      {i.data.tourName}
                                    </span>
                                  </p>
                                  <p class="hotel-row-text-sm">
                                    {i.data.tourLocation}
                                  </p>
                                </div>
                                <div class="makeFlex hrtlCenter">
                                    <p class="hotel-row-hotel-tag">
                                      Land Transfer
                                    </p>
                                  </div>
                                {/* <p class="appendTop15">
                    <span class="transfer-row-text-label">Facilities</span>
                    <span class="appendRight5 transfer-row-text-value relative">
                      3 seater | 2 Luggage Bags | First Aid
                    </span>
                  </p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }

                  {
                    return (
                      <>
                        {DataValue}
                      </>
                    );
                  }
                })
              ) : (
                <>
                  <>
                    <div
                      class="dayplan-section"
                      data-testid="day-plan-section-transfer"
                    >
                      <div class="add-activity-container">
                        <div class="add-activity-card">
                          <p class="add-activity-quote">
                            Craft your perfect itinerary! Connect the dots with
                            convenient transfers.
                          </p>
                        </div>
                        <div
                          id="chooseAndAddBtn"
                          class="add-activity-button"
                          data-testid="add-activity-button"
                          onClick={() =>
                            PopuphandleExperienceTransferListingClick(
                              sequenceDate,
                              itineraryinput?.Location?.label,
                              selectedStartLocation != "" && indexData == 0
                                ? selectedStartLocation
                                : selectedEndLocation != "" &&
                                  DatesOfDay.length == indexData + 1
                                  ? selectedEndLocation
                                  : null
                            )
                          }
                        >
                          <span class="holidaySprite activityIcon"></span>
                          ADD LAND TRANSFER
                        </div>
                      </div>
                    </div>
                  </>
                </>
              )}

              {/* Ferry Transfer */}
              {TransfersFerryselectedData.length > 0 && (
                <>
                  <div
                    class="dayplan-section"
                    data-testid="day-plan-section-transfer"
                  >
                    <div class="add-activity-container">
                      <div class="add-activity-card">
                        <p class="add-activity-quote">
                          Visit other islands: Add ferry to your
                          island-hopping trip.
                        </p>
                      </div>
                      <div
                        id="chooseAndAddBtn"
                        class="add-activity-button"
                        data-testid="add-activity-button"
                        onClick={() =>
                          PopuphandleExperienceTransferFerryListingClick(
                            sequenceDate,
                            itineraryinput?.Location?.label
                          )
                        }
                      >
                        <span class="holidaySprite activityIcon"></span>
                        ADD FERRY
                      </div>
                    </div>
                  </div>
                </>
              )}
              {TransfersFerryselectedData.length > 0 ? (
                TransfersFerryselectedData.map((i, j) => {
                  let dateselected = new Date(i.data.dateselected);
                  let DataValue = "";

                  if (
                    moment(dateselected).format("Y-MM-DD") ===
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        {" "}
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-transfer"
                        >
                          <div
                            class="transfer-row highlight "
                            data-testid="transfer"
                          >
                            <div class="transfer-row-header">
                              <p class="transfer-row-title">
                                {i.data.tourLocation}
                              </p>
                              <div
                                id="changeRemoveBtn"
                                class="transfer-row-btns"
                              >
                                <span
                                  id="remove"
                                  onClick={() => handleRemove(i?.index)}
                                >
                                  Remove
                                </span>
                                <span
                                  onClick={() =>
                                    i.data.profileactivity == "Transfers"
                                      ? PopuphandleExperienceTransferListingClick(
                                        sequenceDate,
                                        itineraryinput?.Location?.label,
                                        selectedStartLocation != "" &&
                                          indexData == 0
                                          ? selectedStartLocation
                                          : selectedEndLocation != "" &&
                                            DatesOfDay.length == indexData + 1
                                            ? selectedEndLocation
                                            : null,
                                        i?.index
                                      )
                                      : i.data.profileactivity == "TransfersFerry"
                                        ? PopuphandleExperienceTransferFerryListingClick(
                                          sequenceDate,
                                          itineraryinput?.Location?.label,
                                          i?.index
                                        )
                                        : PopuphandleExperienceListingClick(
                                          sequenceDate,
                                          itineraryinput?.Location?.label,
                                          i?.index
                                        )
                                  }
                                >
                                  Change
                                </span>
                              </div>
                            </div>
                            <div class="transfer-row-body">
                              <figure class="transfer-row-image-wrapper">
                                <div class=" image-carousel-slide ">
                                  <div
                                    class="imageLoaderContainer "
                                    style={{
                                      width: "243px",
                                      height: "144px",
                                    }}
                                  >
                                    <img
                                      class="borderRadius4 vrtTop active "
                                      width="243"
                                      height="144"
                                      src={i.data.tourImage}
                                    />
                                  </div>
                                </div>
                              </figure>
                              <div class="transfer-row-details">
                                <div class="transfer-row-details-title">
                                  <p class="greyText">
                                    <span class="font14 latoBlack blackText">
                                      {i.data.tourName}
                                    </span>
                                  </p>
                                  <p class="hotel-row-text-sm">
                                    {i.data.tourLocation}
                                  </p>
                                </div>
                                <div class="makeFlex hrtlCenter">
                                    <p class="hotel-row-hotel-tag">
                                       Ferry
                                    </p>
                                  </div>
                                {/* <p class="appendTop15">
                    <span class="transfer-row-text-label">Facilities</span>
                    <span class="appendRight5 transfer-row-text-value relative">
                      3 seater | 2 Luggage Bags | First Aid
                    </span>
                  </p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }

                  {
                    return (
                      <>
                        {DataValue}
                      </>
                    );
                  }
                })
              ) : (
                <>
                  <>
                    <div
                      class="dayplan-section"
                      data-testid="day-plan-section-transfer"
                    >
                      <div class="add-activity-container">
                        <div class="add-activity-card">
                          <p class="add-activity-quote">
                            Visit other islands: Add ferry to your
                            island-hopping trip.
                          </p>
                        </div>
                        <div
                          id="chooseAndAddBtn"
                          class="add-activity-button"
                          data-testid="add-activity-button"
                          onClick={() =>
                            PopuphandleExperienceTransferFerryListingClick(
                              sequenceDate,
                              itineraryinput?.Location?.label
                            )
                          }
                        >
                          <span class="holidaySprite activityIcon"></span>
                          ADD FERRY
                        </div>
                      </div>
                    </div>
                  </>
                </>
              )}
              {/* Attraction Data */}
              {AttractionselectedData.length > 0 && (
                <>
                  <div
                    class="dayplan-section"
                    data-testid="day-plan-section-activity"
                  ></div>
                  <div class="add-activity-container">
                    <div class="add-activity-card">
                      <p class="add-activity-quote">
                        Add amazing attractions and things to do to
                        your itinerary!
                      </p>
                    </div>
                    <div
                      id="chooseAndAddBtn"
                      class="add-activity-button"
                      data-testid="add-activity-button"
                      onClick={() =>
                        PopuphandleExperienceListingClick(
                          sequenceDate,
                          itineraryinput?.Location?.label
                        )
                      }
                    >
                      <span class="holidaySprite activityIcon"></span>
                      ADD ACTIVITY
                    </div>
                  </div>
                </>
              )}
              {AttractionselectedData.length > 0 ? (
                AttractionselectedData.map((i, j) => {
                  let dateselected = new Date(i.data.dateselected);
                  let DataValue = "";

                  if (
                    moment(dateselected).format("Y-MM-DD") ===
                    moment(sequenceDate).format("Y-MM-DD")
                  ) {
                    DataValue = (
                      <>
                        {" "}
                        <div
                          class="dayplan-section"
                          data-testid="day-plan-section-transfer"
                        >
                          <div
                            class="transfer-row highlight "
                            data-testid="transfer"
                          >
                            <div class="transfer-row-header">
                              <p class="transfer-row-title">
                                {i.data.tourLocation}
                              </p>
                              <div
                                id="changeRemoveBtn"
                                class="transfer-row-btns"
                              >
                                <span
                                  id="remove"
                                  onClick={() => handleRemove(i.index)}
                                >
                                  Remove
                                </span>
                                <span
                                  onClick={() =>
                                    i.data.profileactivity == "Transfers"
                                      ? PopuphandleExperienceTransferListingClick(
                                        sequenceDate,
                                        itineraryinput?.Location?.label,
                                        selectedStartLocation != "" &&
                                          indexData == 0
                                          ? selectedStartLocation
                                          : selectedEndLocation != "" &&
                                            DatesOfDay.length == indexData + 1
                                            ? selectedEndLocation
                                            : null,
                                        i?.index
                                      )
                                      : i.data.profileactivity == "TransfersFerry"
                                        ? PopuphandleExperienceTransferFerryListingClick(
                                          sequenceDate,
                                          itineraryinput?.Location?.label,
                                          i?.index
                                        )
                                        : PopuphandleExperienceListingClick(
                                          sequenceDate,
                                          itineraryinput?.Location?.label,
                                          i?.index
                                        )
                                  }
                                >
                                  Change
                                </span>
                              </div>
                            </div>
                            <div class="transfer-row-body">
                              <figure class="transfer-row-image-wrapper">
                                <div class=" image-carousel-slide ">
                                  <div
                                    class="imageLoaderContainer "
                                    style={{
                                      width: "243px",
                                      height: "144px",
                                    }}
                                  >
                                    <img
                                      class="borderRadius4 vrtTop active "
                                      width="243"
                                      height="144"
                                      src={i.data.tourImage}
                                    />
                                  </div>
                                </div>
                              </figure>
                              <div class="transfer-row-details">
                                <div class="transfer-row-details-title">
                                  <p class="greyText">
                                    <span class="font14 latoBlack blackText">
                                      {i.data.tourName}
                                    </span>
                                  </p>
                                  <p class="hotel-row-text-sm">
                                    {i.data.tourLocation}
                                  </p>
                                </div>
                                <div class="makeFlex hrtlCenter">
                                    <p class="hotel-row-hotel-tag">
                                        Activity
                                    </p>
                                  </div>
                                {/* <p class="appendTop15">
                    <span class="transfer-row-text-label">Facilities</span>
                    <span class="appendRight5 transfer-row-text-value relative">
                      3 seater | 2 Luggage Bags | First Aid
                    </span>
                  </p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  }

                  {
                    return (
                      <>
                        {DataValue}
                      </>
                    );
                  }
                })
              ) : (
                <>
                  <>
                    <div
                      class="dayplan-section"
                      data-testid="day-plan-section-activity"
                    ></div>
                    <div class="add-activity-container">
                      <div class="add-activity-card">
                        <p class="add-activity-quote">
                          Add amazing attractions and things to do to your
                          itinerary!
                        </p>
                      </div>
                      <div
                        id="chooseAndAddBtn"
                        class="add-activity-button"
                        data-testid="add-activity-button"
                        onClick={() =>
                          PopuphandleExperienceListingClick(
                            sequenceDate,
                            itineraryinput?.Location?.label
                          )
                        }
                      >
                        <span class="holidaySprite activityIcon"></span>
                        ADD ACTIVITY
                      </div>
                    </div>
                  </>
                </>
              )}
            </div>
          ),
        });
      });
    setTabData(resultData);
  }, [DatesOfDay, selectedData]);
  // }, [DatesOfDay]);

  useEffect(() => {
    const sortedData = Object.entries(selectedData)
      .map(([key, item], index) => ({ index, key, item }))
      .sort((a, b) => {
        let accodata = moment(a.item.time, ["HH.mm"]).format("hh:mm a");
        let accodatb = moment(b.item.time, ["HH.mm"]).format("hh:mm a");

        if (a.item.time === null && b.item.time === null) {
          return a.index - b.index;
        }
        // If one value is null, move it to the end
        if (a.item.time === null) return 1;
        if (b.item.time === null) return -1;

        if (a.item.time != null) {
          return accodata.localeCompare(accodatb);
        }
        return a.key.localeCompare(b.key);
      })
      .map(({ item }) => item);

    const resultSummaryData = [];
    DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        resultSummaryData.push({
          label: moment(sequenceDate).format("DD MMM Y"),

          content: (
            // <div className="dayRowContainer">
            <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
              {sortedData.length > 0 &&
                sortedData.map((i, j) => {
                  // let date1 = new Date(i.startDate);
                  // let date2 = new Date(i.endDate);
                  let dateselected = new Date(i.dateselected);

                  let DataValue = "";

                  if (i.profileactivity != "Accommodations") {
                    if (
                      moment(dateselected).format("Y-MM-DD") ===
                      moment(sequenceDate).format("Y-MM-DD")
                    ) {
                      DataValue = (
                        <>
                          <div class="dayRowContainer">
                            <div className="summaryDetailWrapper">
                              <div className="summaryDetailContainer">
                                <span className="font12 hotel-row-text-date-summary">
                                  <b>
                                    {i?.time == null ? (
                                      <>Coordinated Timing</>
                                    ) : (
                                      <>{i?.time}</>
                                    )}{" "}
                                  </b>
                                </span>
                                <span className="font12">
                                  {i?.time == null ? (
                                    <>
                                      Coordinated Timing for{" "}
                                      <b>
                                        {i?.tourName} {i?.tourLocation}:
                                      </b>{" "}
                                      The supplier will contact you to organise.{" "}
                                    </>
                                  ) : (
                                    <>
                                      {i?.tourName} {i?.tourLocation}
                                    </>
                                  )}
                                </span>
                                <span className="font12"></span>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    }
                  } else {
                    if (
                      moment(i.startDate).format("Y-MM-DD") <=
                      moment(sequenceDate).format("Y-MM-DD") &&
                      moment(i.endDate).format("Y-MM-DD") >
                      moment(sequenceDate).format("Y-MM-DD")
                    ) {
                      if (
                        moment(i.startDate).format("Y-MM-DD") ===
                        moment(sequenceDate).format("Y-MM-DD")
                      ) {
                        DataValue = (
                          <>
                            <div class="dayRowContainer">
                              <div className="summaryDetailWrapper">
                                <div className="summaryDetailContainer">
                                  <p className="font12 hotel-row-text-date-summary">
                                    <b>
                                      {moment(i.checkin, ["h:mm A"]).format(
                                        "hh A"
                                      )}
                                      { }
                                    </b>
                                  </p>
                                  <span className="font12">
                                    Check in to <b>{i.propertyName} </b>{" "}
                                    {i.propertylocation}
                                  </span>
                                </div>
                                {/* <span className="verticalBar downBar"></span> */}
                              </div>
                              {/* <div className="summaryDetailWrapper"></div> */}
                            </div>
                          </>
                        );
                      }
                    } else {
                      if (
                        moment(i.endDate).format("Y-MM-DD") ===
                        moment(sequenceDate).format("Y-MM-DD")
                      ) {
                        DataValue = (
                          <>
                            <div class="dayRowContainer">
                              <div className="summaryDetailWrapper">
                                <div className="summaryDetailContainer">
                                  <p className="font12 hotel-row-text-date-summary">
                                    <b>
                                      {moment(i.checkout, ["h:mm A"]).format(
                                        "hh A"
                                      )}
                                      { }
                                    </b>
                                  </p>
                                  <span className="font12">
                                    Check-out to <b>{i.propertyName} </b>{" "}
                                    {i.propertylocation}
                                  </span>
                                </div>
                                {/* <span className="verticalBar downBar"></span> */}
                              </div>
                              {/* <div className="summaryDetailWrapper"></div> */}
                            </div>
                          </>
                        );
                      }
                    }
                  }
                  {
                    return DataValue;
                  }
                })}
            </div>
          ),
        });
      });
    setSummaryTabData(resultSummaryData);
  }, [DatesOfDay]);

  const displayPayment = () => {
    const TotalPrice = selectedData.reduce(
      (amount, item) => parseFloat(item.price) + amount,
      0
    );

    // const TaxandFee = selectedData.reduce((tax, item) => parseFloat(item.taxamount) + tax, 0)
    const TaxandFee = 0;
    let TotalPriceInclude = TaxandFee + TotalPrice;

    let FinalPrice = parseFloat(TotalPriceInclude);
    return (
      <>
        <p class="font16" style={{ marginBottom: "10px" }}>
          PRICE BREAK-UP
        </p>
        {/* <p class="slashedPrice">  <span>€</span>
              {TotalPrice.toFixed(2)}</p> */}
        <p class="font12">
          <span id="price_detail" class="font24 latoBlack">
            <span>€ {TotalPrice.toFixed(2)}</span>
          </span>{" "}
        </p>
        {/* <p class="font10 greyText">*Including all taxes</p>
      <span class="pakageOfftag">41% OFF</span>  */}
      </>
    );
  };

  const handleRemove = (index) => {
    dispatch(removeToCart(index));
    // window.location.reload(true);
    // setTimeout(() => {
    //   window.location.reload(true);
    // }, 2000);
  };
  const handleClear = () => {
    dispatch(clearToCart());
    setTimeout(() => {
      const url =
        "/makebuildtrip?moreLocation=" +
        encodeURIComponent(addMoreLocation) +
        "&checkin=" +
        encodeURIComponent(startDate) +
        "&checkout=" +
        encodeURIComponent(endDate) +
        "&guestCombination=" +
        JSON.stringify(cats);
      window.location.replace(url);
    }, 1000);
  };
  const handleItineraryClear = () => {
    let text = "Are you sure want clear to Itinerary";
    if (window.confirm(text) == true) {
      dispatch(clearToCart());
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    }
  };

  let closeModal = () => {
    setopenModal(false);
  };

  let ConfirmBooking = (e) => {
    e.preventDefault();

    const reduxselectedData = selectedData;

    checkAvailabilityCheckoutData(reduxselectedData).then(
      (data) => {
        let checkDataAvail = "";
        data.map((checkDataNew, indexJax) => {
          if (
            (checkDataNew.expreience &&
              checkDataNew?.expreience[0]["options"][0]["timing"] ==
              "unavailable") ||
            (checkDataNew.accomodation &&
              checkDataNew?.accomodation.toString() === "notavil")
          ) {
            checkDataAvail = "NoAvaillable";
          }
        });
        if (checkDataAvail == "NoAvaillable") {
          setopenModal(true);
        } else {
          setTimeout(() => {
            const url = "/paymentcart";
            window.location.replace(url);
          }, 1000);
        }
        setcheckAvailData(data);
      },
      (error) => { }
    );
    setreduxData(selectedData);
  };

  let ContinuePayment = (e) => {
    checkAvailData != null &&
      checkAvailData.length > 0 &&
      checkAvailData.map((checkData, indexJax) => {
        if (
          checkData.expreience &&
          checkData.expreience[0]["options"][0]["timing"] == "unavailable"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                dispatch(removeToCart(indexJ));
              }
            })
          );
        } else if (
          checkData.accomodation &&
          checkData.accomodation.toString() == "notavil"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                dispatch(removeToCart(indexJ));
              }
            })
          );
        }
      });

    setTimeout(() => {
      const url = "/paymentcart";
      window.location.replace(url);
    }, 1000);
  };

  let loginPage = (e) => {
    e.preventDefault();
    setmodalIsOpen(true);
  };

  let ChangeLoginScreen = () => {
    setChangeLoginScreenClass("containerLogin right-panel-active");
  };
  let ChangeLoginReverse = () => {
    setChangeLoginScreenClass("containerLogin");
  };

  let ChangeLoginEmail = (event) => {
    setLoginEmail(event.target.value);
  };

  let ChangeLoginPassword = (event) => {
    setLoginPassword(event.target.value);
  };
  let LoginConfirm = (e) => {
    e.preventDefault();
    seterrorPassword(false);
    let emailNew = LoginEmail;
    let email = "";
    if (emailNew.length > 0) {
      email = emailNew;
    } else {
      email = cookies.userDetails.email;
    }
    let password = LoginPassword;

    LoginConfirmation(email, password).then(
      (data) => {
        if (data == "not_correct") {
          seterrorPassword(true);
        } else {
          setcustomerDetails(data);

          let Verified = "";
          if (data.verified == 1) {
            Verified = true;
          }

          const dataSearch = {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            country_code: data.country_code,
            verified: Verified,
            uid: data.id,
          };

          let JsonData = JSON.stringify(dataSearch);

          localStorage.setItem("userDetails", JsonData);
          window.location.reload(true);
        }
      },
      (error) => { }
    );
  };

  let LoginFaceBook = (e) => {
    e.preventDefault();
    setfacebookLogin(true);
  };

  let responseFacebook = (response) => {
    if (response.accessToken) {
      setfacebookResponse(response);
      let Name = response.first_name;

      let first_name = response.first_name;
      let last_name = response.last_name;
      let email = response.email;
      let profile_image = response.picture.data.url;
      let birthday = moment(response.birthday).format("Y-MM-DD");
      let gender = response.gender;
      let login_source = 1;

      let mobile_number = "";
      let country1 = country;
      let country_code1 = country_code;
      let currency1 = currency;
      let ip_address1 = ip_address;
      let password = "";
      let verified = 1;

      let Verified = "";
      if (verified == 1) {
        Verified = true;
      }

      const dataSearch = {
        first_name: first_name,
        last_name: last_name,
        email: email,
        country_code: country_code,
        verified: Verified,
        uid: "",
      };

      let JsonData = JSON.stringify(dataSearch);

      localStorage.setItem("userDetails", JsonData);
      setCookie("userDetails", JsonData, { path: "/" });

      setCustomerLogin(
        first_name,
        last_name,
        email,
        profile_image,
        birthday,
        gender,
        login_source,
        mobile_number,
        country1,
        country_code1,
        currency1,
        ip_address1,
        password,
        verified
      ).then(
        (data) => {
          if (data.id > 0) {
            window.location.reload(true);
          }
        },
        (error) => { }
      );
      setmodalIsOpen(false);
      // window.location.reload(true);
    }
  };

  let responseGoogle = (response) => {
    if (response.accessToken) {
      setGoogleResponse(response);

      let first_name = response.profileObj.givenName;
      let last_name = response.profileObj.familyName;
      let email = response.profileObj.email;
      let profile_image = response.profileObj.imageUrl;
      let birthday = "";
      let gender = "";
      let login_source = 2;

      let mobile_number = "";
      let country1 = country;
      let country_code1 = country_code;
      let currency1 = currency;
      let ip_address1 = ip_address;
      let password = "";
      let verified = 1;

      let Verified = "";
      if (verified == 1) {
        Verified = true;
      }

      const dataSearch = {
        first_name: first_name,
        last_name: last_name,
        email: email,
        country_code: country_code,
        verified: Verified,
        uid: "",
      };

      let JsonData = JSON.stringify(dataSearch);

      localStorage.setItem("userDetails", JsonData);
      setCookie("userDetails", JsonData, { path: "/" });

      setCustomerLogin(
        first_name,
        last_name,
        email,
        profile_image,
        birthday,
        gender,
        login_source,
        mobile_number,
        country1,
        country_code1,
        currency1,
        ip_address1,
        password,
        verified
      ).then(
        (data) => {
          if (data.id > 0) {
            window.location.reload(true);
          }
        },
        (error) => { }
      );
      setmodalIsOpen(false);
      //window.location.reload(true);
    }
  };

  let OnChangeTripPlanName = (event) => {
    let tripname = event.target.value;
    let lastregMatch = /^[a-zA-Z0-9 ]*$/.test(event.target.value);
    const sanitizedValue = tripname.replace(/[^\w\s]/gi, ""); // Regex to remove special characters
    if (tripname !== sanitizedValue) {
      setTripPlanNameErrorMessage("Special characters are not allowed.");
    } else if (event.target.value.length <= 3 && lastregMatch) {
      setTripPlanNameErrorMessage("Input must be at least 3 characters long");
    } else if (event.target.value.length >= 50 && lastregMatch) {
      setTripPlanNameErrorMessage("Input must be maximum 50 characters long");
    } else {
      setTripPlanNameErrorMessage("");
    }

    setTripPlanNameValue(tripname);
  };

  let closePlanModal = () => {
    setopenPlanModal(false);
  };
  let AddToTripPlan = (e) => {
    e.preventDefault();
    setopenPlanModal(true);
  };

  let planTripSaveWishlist = (e) => {
    let CheckError = false;
    let lastregMatch = /^[a-zA-Z0-9 ]*$/.test(tripPlanNameValue);
    const sanitizedValue = tripPlanNameValue.replace(/[^\w\s]/gi, ""); // Regex to remove special characters
    if (tripPlanNameValue !== sanitizedValue) {
      CheckError = true;
      setTripPlanNameErrorMessage("Special characters are not allowed.");
    } else if (tripPlanNameValue.length <= 3 && lastregMatch) {
      CheckError = true;
      setTripPlanNameErrorMessage("Input must be at least 3 characters long");
    } else if (tripPlanNameValue.length >= 50 && lastregMatch) {
      CheckError = true;
      setTripPlanNameErrorMessage("Input must be maximum 50 characters long");
    } else {
      CheckError = false;
      setTripPlanNameErrorMessage("");
    }

    if (CheckError == false) {
      let reduxdata = selectedData;
      let plantripname = tripPlanNameValue;
      let customer = JSON.parse(customerDetails);
      let customer_id = customer?.uid;
      let checkin_date = moment(startDate).format("Y-MM-DD");
      let checkout_date = moment(endDate).format("Y-MM-DD");
      let moreLocation = JSON.parse(addMoreLocation);
      let guest_combination = cats;
      let itinerary_plan = JSON.parse(itineraryPlan);
      let change_date = changeDate;
      let selectedNewStartLocation = selectedStartLocation;
      let selectedNewEndLocation = selectedEndLocation;

      WishlistfitCartAdd(
        reduxdata,
        plantripname,
        customer_id,
        servicedate,
        checkin_date,
        checkout_date,
        moreLocation,
        guest_combination,
        itinerary_plan,
        change_date,
        selectedNewStartLocation,
        selectedNewEndLocation
      ).then(
        (data) => {
          alert(
            'Your booking items have been added to My Trip Plan. To view them click "My Trip Plan" in the top menu under the profile button.'
          );
          setopenPlanModal(false);
        },
        (error) => { }
      );
      //}
    }
  };

  const TotalPriceAll = selectedData.reduce(
    (amount, item) => parseFloat(item.totalAmount) + amount,
    0
  );
  const TotalPrice = selectedData.reduce(
    (amount, item) => parseFloat(item.price) + amount,
    0
  );
  const TaxandFee = 0;
  let TotalPriceInclude = TaxandFee + TotalPrice;
  //  let CommissionPrice = (parseFloat(Commission) / 100) * TotalPriceInclude;
  // let FinalPrice = parseFloat(TotalPriceInclude - CommissionPrice);
  let OfferPrice = TotalPriceAll - TotalPriceInclude;
  let JsonStatePDFAcco = {
    booking_amount: TotalPriceInclude,
    total_main_amount: TotalPriceAll,
    offer_discount: OfferPrice,
    // commission_price:CommissionPrice,
    numberof_night: 2,
    agentdetails: customerDetails,
    child: selectedData,
    dayPlan: DatesOfDay,
    itineraryDetails: itineraryDetails,
    planname: planname,
    totalDays: totalDays,
    startDate: startDate,
    endDate: endDate,
    selectedStartLocation: selectedStartLocation,
    selectedEndLocation: selectedEndLocation,
  };
  const itinerarypdf = JSON.stringify(JsonStatePDFAcco);
  let openModalShareDiv = () => {
    setopenModalShare(true);
  };

  let closeModalShareDiv = () => {
    setopenModalShare(false);
  };
  const generatePdfLink = () => {
    // const pdfBlob = new Blob([<InvoiceItinerary  invoice={
    //   itinerarypdf
    // } />], { type: 'application/pdf' });
    // const url = URL.createObjectURL(pdfBlob);
    // setPdfLink(url);
    let JsonStatePDFLink = {
      booking_amount: TotalPriceInclude,
      total_main_amount: TotalPriceAll,
      offer_discount: OfferPrice,
      // commission_price:CommissionPrice,
      numberof_night: 2,
      agentdetails: customerDetails,
      child: selectedData,
      dayPlan: DatesOfDay,
      itineraryDetails: itineraryDetails,
      planname: planname,
      totalDays: totalDays,
      startDate: startDate,
      endDate: endDate,
    };
    const itinerarypdfLink = JSON.stringify(JsonStatePDFLink);

    // Use a unique filename or identifier for the PDF
    const filename = "example.pdf";

    // Create a Blob with the PDF content
    const pdfBlob = new Blob(
      [<InvoiceItinerary invoice={itinerarypdfLink} />],
      { type: "application/pdf" }
    );

    // Generate a data URL for the Blob
    const dataUrl = URL.createObjectURL(pdfBlob);

    // Set the generated link to state
    setPdfLink(dataUrl);
  };

  let OnChangeEmailId = (event) => {
    const email = validEmailRegex.test(event.target.value);
    if (email == true) {
      setEmailId(event.target.value);
      setEmailError(false);
    } else {
      setEmailId(event.target.value);
      setEmailError(true);
    }
  };

  let sharePlantrip = (e) => {
    let CheckErrorEmail = false;
    const email = validEmailRegex.test(EmailId);
    if (email == true) {
      setEmailError(false);
      CheckErrorEmail = true;
    } else {
      CheckErrorEmail = false;
      setEmailError(true);
    }
    if (CheckErrorEmail == true) {
      let reduxdata = JsonStatePDFAcco;
      let emailID = EmailId;
      let customer = JSON.parse(customerDetails);
      let customer_id = customer?.uid;
      let selectedNewStartLocation = selectedStartLocation;
      let selectedNewEndLocation = selectedEndLocation;

      shareItineraryDetails(
        reduxdata,
        emailID,
        customer_id,
        selectedNewStartLocation,
        selectedNewEndLocation
      ).then(
        (data) => {
          alert("Your Itinerary Plan has submit");
          setopenModalShare(false);
        },
        (error) => { }
      );
    }
  };
  // console.log("localdata",localStorage.getItem('accomodationSlide'));
  return (
    <div className="Detail-container">
      <Helmet>
        <title>Book Best Hotels in seychelles- Holidays Seychelles</title>
        <meta
          name="description"
          content="Book best hotels in Seychelles at affordable prices."
        />
        <meta
          name="keywords"
          content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
        />
      </Helmet>
      <h1 style={{ color: "#fff" }}>
        Book Best Hotels in seychelles- Holidays Seychelles
      </h1>
      <NewHeader page={"inner"} />
      <TabContext value={value}>
        <div className="topSection newTopSection appendBottom20">
          <div className="pageContainer">
            <div className="appendBottom15 pageHeading">
              {/* <div className="message-banner hideMessageBanner successBannerColor">
                <p className="message-banner-text"></p>
              </div> */}
              <div className="makeFlex">
                <span className="topHeading">{planname}</span>
                {/* <TextEditor/> */}
              </div>
              <div className="topSubBar">
                <div className="topSubHead">
                  {/* <div className="packageTypeTagV2">
                  <div className="group-icon">
                    <svg
                      width="13"
                      height="9"
                      viewBox="0 0 13 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    ></svg>
                  </div>
                  <div className="flexiPakageTip">
                    <p className="latoBold appendBottom6">Highlights</p>
                    <ul>
                      <li>Customise the package as per need</li>
                      <li>Just your friends/family</li>
                    </ul>
                  </div>
                  <span className="font11  widthMaxContent ">
                      Customizable
                    </span>
                </div> */}
                  <div className="packageTypeTagV2">
                    <span className="font11  widthMaxContent">
                      {" "}
                      {totalDays}N/{totalDays + 1}D
                    </span>
                  </div>
                  <p className="duration-text">
                    {itineraryDetails.length &&
                      itineraryDetails.map((plan, index) => (
                        <>
                          {`${plan.name}N ${plan?.Location?.label} `}
                          <span className="black-dot"></span>
                        </>
                      ))}
                    {/* 2N Mahe
                    <span className="black-dot"></span>
                    2N Victoria
                    <span className="black-dot"></span>
                    2N Praslin */}
                  </p>
                </div>
              </div>

              <div className="topSubBar">
                <div className="topSubHead">
                  {/* <div className="packageTypeTagV2">
                  <span className="font11  widthMaxContent">
                    {" "}
                    {totalDays}N/{totalDays + 1}D
                  </span>
                </div> */}
                  <p className="duration-text">
                    {selectedStartLocation != "" && (
                      <>Start: {selectedStartLocation}</>
                    )}
                    -{" "}
                    {selectedEndLocation != "" && (
                      <>End: {selectedEndLocation}</>
                    )}
                    {/* 2N Mahe
                    <span className="black-dot"></span>
                    2N Victoria
                    <span className="black-dot"></span>
                    2N Praslin */}
                  </p>
                </div>
              </div>
            </div>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              id="tabItem"
              className="mainTab"
            >
              <Tab className="mainTabItem" label="ITINERARY" value="1" />
              <Tab className="mainTabItem" label="SUMMARY" value="2" />

              {/* <div id="tabItem" className="mainTab"> */}
              {/* <div className="mainTabItem active">ITINERARY</div> */}
              {/* <div className="mainTabItem false">CANCELLATION POLICIES</div> */}
              {/* <div className="mainTabItem false">SUMMARY</div> */}
              <div className="flexOne">
                {Object.entries(selectedData).length > 0 && (
                  <ul className="actionIcons makeFlex right appendTop15 appendRight15">
                    <li className="makeFlex perfectCenter cursorPointer">
                      <span className="holidaySprite icon24 share appendRight3"></span>
                      <i
                        className="fa fa-print"
                        aria-hidden="true"
                        style={{ paddingRight: "2px" }}
                      ></i>{" "}
                      {
                        <PDFDownloadLink
                          document={<InvoiceItinerary invoice={itinerarypdf} />}
                          fileName="ItineraryDetails.pdf"
                          style={{
                            fontSize: "12px",
                            color: "#ff0000",
                            fontWeight: "200",
                          }}
                        >
                          {({ blob, url, loading, error }) =>
                            loading
                              ? "Loading document..."
                              : "Download Itinerary"
                          }
                        </PDFDownloadLink>
                      }
                    </li>

                    <li
                      className="makeFlex perfectCenter cursorPointer"
                      onClick={
                        customerDetails == "abc" ? loginPage : openModalShareDiv
                      }
                    >
                      <span className="holidaySprite icon24 share appendRight3"></span>
                      <i
                        className="fa fa-share"
                        aria-hidden="true"
                        style={{ paddingRight: "2px" }}
                      ></i>{" "}
                      Share Plan
                    </li>
                    <li className="makeFlex perfectCenter cursorPointer">
                      <span className="holidaySprite icon24 share appendRight3"></span>
                      { }
                      <div
                        className="add-Itinerary-button"
                        onClick={
                          customerDetails == "abc" ? loginPage : AddToTripPlan
                        }
                      >
                        <span class="holidaySprite activityIcon"></span>Save
                      </div>
                    </li>
                  </ul>
                )}
              </div>
            </TabList>
          </div>
        </div>

        <div class="pageContainer makeFlex spaceBetween">
          <div class="leftContainer">
            <div class="left-section">
              <TabPanel value="1">
                <div class="sme-card">
                  <div class="sme-cardTop"></div>
                </div>
                <ul
                  class="initerary-nav "
                  id="initeraryNav"
                  data-testid="itinerary-nav"
                >
                  <li class="active">
                    <b class="appendRight3">{DatesOfDay.length}</b> Day
                    Itinerary
                  </li>
                  <li class="  ">
                    <b class="appendRight3">{accommodationLen}</b> Hotels
                  </li>
                  <li class="  ">
                    <b class="appendRight3">{transferLen}</b> Transfers
                  </li>
                  <li class="  ">
                    <b class="appendRight3">{transferFerryLen}</b> Ferry
                    Transfer
                  </li>
                  <li class=" ">
                    <b class="appendRight3">{attractionLen}</b> Activities
                  </li>
                </ul>
                {tabData.length > 0 && (
                  <VerticalTabsScrollable tabs={tabData} />
                )}
              </TabPanel>
              <TabPanel value="2">
                {summaryTabData.length > 0 && (
                  <Summarydetails summaryTabData={summaryTabData} />
                )}
              </TabPanel>
            </div>
          </div>
          <div class="rightContainer">
            <div class="pakageDtlWrap appendBottom20">
              <div class="pakageDtlWrapTop">
                {/* <p class="font16">PRICE BREAK-UP</p> */}
                {displayPayment()}
                {/* <p class="slashedPrice"> ₹70,039</p>
              <p class="font12">
                <span id="price_detail" class="font24 latoBlack">
                  <span>₹41,616</span>
                </span>{" "}
              </p>
              <p class="font10 greyText">*Including all taxes</p>
              <span class="pakageOfftag">41% OFF</span> */}
              </div>
              <div class="pakageDtlWrapBottom">
                <div class="pakageDtlRow">
                  <div class="makeFlex appendBottom6">
                    {/* <span class="holidaySprite icon24 flexiDateIcon"></span> */}
                    <div class="flexOne makeFlex spaceBetween">
                      <span class="latoBlack">
                        {moment(startDate).format("DD MMM")} -{" "}
                        {moment(endDate).format("DD MMM")}{" "}
                      </span>
                      <Link
                        class="latoBold pointer link link-secondary"
                        onClick={() => handleClear()}
                      >
                        Modify
                      </Link>
                    </div>
                  </div>
                </div>
                {Object.entries(selectedData).length > 0 && (
                  <>
                    <div class="pakageDtlCta" id="continue">
                      <span
                        class="dangerBtn fill btn btn-danger btn-sm"
                        onClick={() => handleItineraryClear()}
                      >
                        Clear To Itinerary
                      </span>
                    </div>

                    <div class="pakageDtlCta" id="continue">
                      <span
                        class="primaryBtn fill btn btn-primary btn-sm"
                        onClick={
                          customerDetails == "abc" ? loginPage : ConfirmBooking
                        }
                      >
                        PROCEED TO BOOK
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </TabContext>
      <Slider
        id="demoID2"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopuphandleCloseClick}
        toggle={slideShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupItineraryDetails}
      />
      <Slider
        id="demoID3"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperiencehandleCloseClick}
        toggle={slideExperienceShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceItinerary}
      />
      <Slider
        id="demoID4"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperienceTransferhandleCloseClick}
        toggle={slideExperienceTransferShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceTransferItinerary}
      />
      <Slider
        id="demoID5"
        animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperienceTransferFerryhandleCloseClick}
        toggle={slideExperienceTransferFerryShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceTransferFerryItinerary}
      />

      <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="backdrop"
        isOpen={openModal}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
      >
        <div className="modalCont">
          <span className="closeButton" onClick={closeModal}>
            Close
          </span>
          {checkAvailData != null &&
            checkAvailData.length > 0 &&
            checkAvailData.map((checkData, indexJax) => {
              if (
                (checkData.expreience &&
                  checkData.expreience[0]["options"][0]["timing"] ==
                  "unavailable") ||
                (checkData.accomodation && checkData.accomodation == "notavil")
              ) {
                <h4>No Cart Availability :</h4>;
              }
            })}
          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <b>
                  The availability changes rapidly. Your following bookings
                  availability has been changed.
                </b>
              </div>
            </div>
            <div>
              <table class="table table-striped">
                <thead>
                  {checkAvailData != null &&
                    checkAvailData.length > 0 &&
                    checkAvailData.map((checkData, indexJax) => {
                      //console.log(checkData);
                      if (
                        (checkData.expreience &&
                          checkData.expreience[0]["options"][0]["timing"] ==
                          "unavailable") ||
                        (checkData.accomodation &&
                          checkData.accomodation.toString() == "notavil")
                      ) {
                        return (
                          <tr>
                            <th scope="col">Option</th>
                            <th scope="col">Booking Item </th>
                            <th scope="col">Requested Availability </th>
                            <th scope="col">Current Availability </th>
                          </tr>
                        );
                      }
                    })}
                </thead>
                <tbody>
                  {checkAvailData != null &&
                    checkAvailData.length > 0 &&
                    checkAvailData.map((checkData, indexJax) => {
                      if (
                        checkData.expreience &&
                        checkData.expreience[0]["options"][0]["timing"] ==
                        "unavailable"
                      ) {
                        return (
                          reduxData != null &&
                          reduxData.length > 0 &&
                          Object.entries(reduxData).map((i, indexJ) => {
                            if (indexJax === indexJ) {
                              if (i[1].profileactivity != "Accommodations") {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].tourName}</td>
                                    <td>{i[1].traveller}</td>
                                    <td>{i[1].availability}</td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].propertyName}</td>
                                    <td>
                                      {i[1].roombooking
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomBooking}</>;
                                        })}
                                    </td>
                                    <td>
                                      {i[1].cartvalue
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomAvail}</>;
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })
                        );
                      } else if (
                        checkData.accomodation &&
                        checkData.accomodation.toString() == "notavil"
                      ) {
                        return (
                          reduxData != null &&
                          reduxData.length > 0 &&
                          Object.entries(reduxData).map((i, indexJ) => {
                            if (indexJax === indexJ) {
                              if (i[1].profileactivity != "Accommodations") {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].tourName}</td>
                                    <td>{i[1].traveller}</td>
                                    <td>{i[1].availability}</td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].propertyName}</td>
                                    <td>
                                      {i[1].roombooking
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomBooking}</>;
                                        })}
                                    </td>
                                    <td>
                                      {i[1].cartvalue
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomAvail}</>;
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })
                        );
                      }
                    })}
                </tbody>
              </table>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h5>We recommend you to try the following:</h5>
                <p>
                  Try to search again and retry booking after waiting for 5-10
                  mins.
                </p>
                <p>
                  If you're still unable to book, look for an alternative
                  accommodation or experience
                </p>
              </div>
              <div className="latoRegular font16 appendBottom15">
                <button onClick={closeModal} class="btn btn-danger float-left">
                  GO Back To Cart
                </button>
                <button
                  onClick={ContinuePayment}
                  class="btn btn-primary float-left"
                  style={{ float: "right" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <div className={ChangeLoginScreenClass}>
          <div className="form-container sign-up-container">
            <form className="FormCon">
              <h1>Create Account</h1>
              <SignUp
                country_code={country_code}
                currency={currency}
                ip_address={ip_address}
                country={country}
              />
            </form>
          </div>
          {facebookLogin && (
            <FacebookLogin
              appId="426993597895758"
              autoLoad={true}
              fields="first_name, last_name, email, picture, birthday,gender"
              scope="public_profile, email, user_birthday,user_gender"
              returnScopes={true}
              callback={responseFacebook}
            />
          )}

          <div className="form-container sign-in-container">
            <form className="FormCon" action="#">
              <h1>LOG IN</h1>
              {errorPassword && (
                <p className="error"> Email or Password is not correct !</p>
              )}
              <input
                type="email"
                placeholder="Email"
                value={LoginEmail}
                onChange={ChangeLoginEmail}
              />
              <input
                type="password"
                placeholder="Password"
                value={LoginPassword}
                onChange={ChangeLoginPassword}
              />
              <a href="#">Forgot your password?</a>
              <button onClick={LoginConfirm}>LOG IN</button>
              <div className="SocialmakeFlex socialBtnContainer vrtlCenter">
                <div
                  className="SocialmakeFlex fbLoginBtn flexOne"
                  onClick={LoginFaceBook}
                >
                  <span className=" popupSprite popupFbIcon"></span>
                  <span
                    className="font14 whiteText latoBold latoBold"
                    style={{ textTransform: "uppercase" }}
                  >
                    Login with Facebook
                  </span>
                </div>
              </div>
              <div className="SocialmakeFlex socialBtnContainer vrtlCenter">
                <div className="SocialmakeFlex googleLoginBtn flexOne">
                  <span style={{ width: "100%" }}>
                    {" "}
                    <GoogleLogin
                      clientId="924181911314-6ml7tmqad8dkh9ugosligld4b9kkremq.apps.googleusercontent.com"
                      buttonText="Login with Google"
                      onSuccess={responseGoogle}
                      onFailure={responseGoogle}
                      cookiePolicy={"single_host_origin"}
                    />
                  </span>
                </div>
              </div>
            </form>
          </div>
          <div className="overlay-container">
            <div className="overlay">
              <div className="overlay-panel overlay-left">
                <h1>Welcome Back!</h1>
                <p>
                  To keep connected with us please login with your personal info
                </p>
                <button className="ghost" onClick={ChangeLoginReverse}>
                  LOG IN
                </button>
              </div>
              <div className="overlay-panel overlay-right">
                <h1>Hello, Friend!</h1>
                <p>Enter your personal details and start journey with us</p>
                <button className="ghost" onClick={ChangeLoginScreen}>
                  Sign Up
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="backdrop"
        isOpen={openPlanModal}
        onRequestClose={closePlanModal}
      >
        <div className="modalCont">
          {/* <span className="closeButton" onClick={closePlanModal}>
            Close
          </span> */}

          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h3>Trip Plan</h3>
              </div>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h5>Give the name to the Trip Plan </h5>
                <p className="wishlist_para">
                  (For example :- Name of your client)
                </p>
                <div className="width">
                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                    <span className="capText"></span>
                  </p>
                  <input
                    type="text"
                    id="tripname"
                    name="tripname"
                    className="frmTextInput"
                    //value={planname}
                    onChange={(e) => OnChangeTripPlanName(e)}
                    placeholder="Enter Name"
                  />
                  {tripPlanNameErrorMessage && (
                    <p className="error"> {tripPlanNameErrorMessage}</p>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <button
                  onClick={closePlanModal}
                  class="btn btn-danger float-right"
                  style={{ float: "right", marginLeft: "10px" }}
                >
                  Close
                </button>
                <button
                  onClick={planTripSaveWishlist}
                  class="btn btn-primary float-right"
                  style={{ float: "right" }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={openModalShare}
        onRequestClose={closeModalShareDiv}
        className="Modal"
        overlayClassName="backdrop"
      >
        <div className="modalCont">
          <span className="closeButton" onClick={closeModalShareDiv}>
            Close
          </span>
          {/* <h4>Share Rate Plan :</h4> */}
          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <h3>ShareTrip Plan</h3>
              </div>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                {/* <h5>Give the name to the Trip Plan </h5>
                <p className="wishlist_para">
                  (For example :- Name of your client)
                </p> */}
                <div className="width">
                  <p className="font11 appendBottom10 guestDtlsTextLbl">
                    <span className="capText"></span>
                  </p>
                  {/* <button onClick={generatePdfLink}>Generate PDF Link</button> */}
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className={`frmTextInput ${EmailError ? "Err" : ""}`}
                    value={EmailId}
                    onChange={(e) => {
                      OnChangeEmailId(e);
                    }}
                    placeholder="Email ID"
                  />
                  {EmailError && (
                    <p className="error"> Please enter a valid Email ID!</p>
                  )}
                </div>
              </div>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                <button
                  onClick={closeModalShareDiv}
                  class="btn btn-danger float-right"
                  style={{ float: "right", marginLeft: "10px" }}
                >
                  Close
                </button>
                <button
                  onClick={sharePlantrip}
                  class="btn btn-primary float-right"
                  style={{ float: "right" }}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <TawkToWidget />
    </div>
  );
  // }
}

export default ItineraryDetails;
